import React, { cloneElement, JSXElementConstructor, ReactElement, useState } from 'react'

import { Wrap } from '../Base/Base'
import { SimpleDialog } from './SimpleDialog'

interface DialogButtonProps {
  dialogContent: React.ReactNode
  children: ReactElement<any, string | JSXElementConstructor<any>>
  width?: string
}

export function DialogButton({ children, dialogContent, width }: DialogButtonProps) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <SimpleDialog isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <Wrap width={width || '700px'} maxWidth="100%">
          {dialogContent}
        </Wrap>
      </SimpleDialog>
      {cloneElement(children, { onClick: () => setIsOpen(true) })}
    </>
  )
}
